<template>
    <el-dialog title="修改预约被拒" width="500px" :visible.sync="dialogVisible" :show-close="true"
               :close-on-click-modal="false" :close-on-press-escape="false">
        <div class="update-reject">
            <div>
                <p>修改说明</p>
                <p>{{item.eventContent}}</p>
            </div>
            <div>
                <p>修改时间</p>
                <p>{{item.appointDate}}</p>
            </div>
            <div>
                <p>是否同意</p>
                <div>
                    <el-radio-group class="sex">
                        <el-radio v-if="item.approveStatus==2">同意</el-radio>
                        <el-radio v-if="item.approveStatus==3">拒绝</el-radio>
                    </el-radio-group>
                    <p v-if="item.approveNote">{{item.approveNote}}</p>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import base from '@/api/common';
import {getAxios} from "@/api/http";

export default {
    name: "update-reject",
    data() {
        return {
            item: {},
            dialogVisible: false
        }
    },
    methods: {
        getData(id) {
            let vm = this;
            getAxios(base.api.appoint.read.replace('{id}', id))
                .then((res) => {
                    if (res.data.status == 'success') {
                        vm.item = res.data.data;
                        if (res.data.data && res.data.data.updateJson) {
                            let obj = JSON.parse(res.data.data.updateJson);
                            let start = new Date(new Date().setHours(obj.timeSlot)).Format('HH:00');
                            let end = new Date(new Date().setHours(obj.timeSlot)).Format('-HH:59');
                            vm.item.appointDate = new Date(obj.appointDate).Format("yyyy年MM月dd日 ") + start + end;
                        }
                        vm.dialogVisible = true;
                    }
                })
        }
    }
}
</script>

<style scoped>

</style>
